import { AlertTriangle, RefreshCw, X } from 'lucide-react';
import { useState } from 'react';

export const DataStatusBanner = ({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className="status-banner" role="alert">
      <AlertTriangle size={17} aria-hidden="true" />
      <span>{message} Showing the last valid market snapshot.</span>
      <button type="button" onClick={onRetry}>
        <RefreshCw size={14} /> Retry
      </button>
      <button type="button" onClick={() => setVisible(false)} aria-label="Dismiss message">
        <X size={14} />
      </button>
    </div>
  );
};
